(ns practitest.frontend.components2.dashboard.charts.line.scales
  (:require
   [practitest.frontend.components2.dashboard.charts.line.helper :as helper]
   ["d3" :as d3]))

(defn- get-x-scale-for-date [chart data]
  (let [{:keys [width]
         :config/keys [padding]} chart
        js-data (clj->js data)
        extent  (-> d3 (.extent js-data (fn [d] (aget d "parsed-x"))))]
    (-> d3
        (.scaleUtc)
        (.domain extent)
        (.range (clj->js [(:left padding) (- width (:right padding))])))))

(defn- get-x-scale-for-digits [chart data]
  (let [{:keys [width]
        :config/keys [padding]} chart
        max-val (if (seq data) (apply max (map :x-data data)) 0)]
    (-> d3
        (.scaleLinear)
        (.domain (clj->js [0 max-val]))
        (.nice)
        (.range (clj->js [(:left padding) (- width (:right padding))])))))

(defn- get-x-scale [chart data]
  (if (:config/date-format-for-x-axis chart)
    (get-x-scale-for-date chart data)
    (get-x-scale-for-digits chart data)))

(defn- get-y-scale [chart data]
  (let [{:config/keys [y-data-minimum-value padding height]} chart
        max-val        (if (seq data) (apply max (map :y-data data)) 0)
        domain-max     (max max-val y-data-minimum-value)]
    (-> d3
        (.scaleLinear)
        (.domain (clj->js [0 domain-max]))
        (.nice)
        (.range (clj->js [(- height (:bottom padding)) (:top padding)])))))


(defn get-scales [chart lines]
  (when-let [domain-data (helper/get-data-with-max-y-data lines)]
    {:x-scale (get-x-scale chart domain-data)
     :y-scale (get-y-scale chart domain-data)}))